export default __webpack_public_path__ + "static/media/sa3.3c445456.jpg";